import { render, staticRenderFns } from "./PModal.vue?vue&type=template&id=a0151c24&scoped=true"
import script from "./PModal.vue?vue&type=script&lang=js"
export * from "./PModal.vue?vue&type=script&lang=js"
import style0 from "./PModal.vue?vue&type=style&index=0&id=a0151c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0151c24",
  null
  
)

export default component.exports